import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import logo from '../../assets/img/logos/PlatoPlanner-logo-white.png';
// @material-ui/icons

// core components
import Footer from '../../components/Footer/Footer.js';
import Parallax from '../../components/Parallax/Parallax.js';
import Button from '../../components/CustomButtons/Button.js';
import { Link } from 'react-router-dom';

import styles from '../../assets/jss/material-kit-react/views/landingPage.js';
import './LandingPage.css';
// Sections for this page
import ProductSection from './Sections/ProductSection.js';
import TeamSection from './Sections/TeamSection.js';

const useStyles = makeStyles(styles);

export default function LandingPage(props) {
  const classes = useStyles();

  return (
    <div>
      <Parallax filter image={require('../../assets/img/landing-bg.jpg')}>
        <div
          className={classes.container}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <div style={{ alignSelf: 'flex-end' }}>
            <Link to='/signup' style={{ textDecoration: 'none' }}>
              <Button color='primary' round>
                Sign up
              </Button>
            </Link>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Link to='/login' style={{ textDecoration: 'none' }}>
              <Button color='info' round>
                Sign in
              </Button>
            </Link>
          </div>
          <img
            src={logo}
            height='380'
            width='602'
            alt='PlatoPlanner Logo'
            className='logo-img'
          />
          <h2 className={classes.title} style={{ margin: 0 }}>
            Realistic, dynamic and result-oriented planning with Plato
          </h2>
          <br />
          <Button
            color='danger'
            size='lg'
            href='/signup'
            rel='noopener noreferrer'
          >
            <i className='fas fa-bullseye'></i>
            Set your first goal with us &nbsp; &nbsp;
          </Button>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <ProductSection />
          <TeamSection />
        </div>
      </div>
      <Footer />
    </div>
  );
}
